import {Component, Input} from '@angular/core';
import {Company} from "../../../../interfaces/company.interface";

@Component({
  selector: 'app-ecosystem',
  templateUrl: './ecosystem.component.html',
  styleUrls: ['./ecosystem.component.scss']
})
export class EcosystemComponent {
  @Input() report: any;
  @Input() company: Company;
  @Input() edit: boolean | undefined;
}
